import { LogLevel } from '@genesislcap/foundation-logger';
/**
 * Retrieves the error details from an ErrorStructure object
 * @public
 * @param details - The ErrorStructure object
 * @returns The title and error details concatenated as a string, or default values ('Error: Something went wrong') if not present
 */
export const getErrorDetails = (details) => {
    var _a, _b;
    const title = (_a = details === null || details === void 0 ? void 0 : details.title) !== null && _a !== void 0 ? _a : 'Error';
    const errorDetails = (_b = details === null || details === void 0 ? void 0 : details.errorDetails) !== null && _b !== void 0 ? _b : 'Something went wrong';
    return `${title}: ${errorDetails}`;
};
/**
 * Retrieves the log level from an ErrorStructure object
 * @public
 * @param details - The ErrorStructure object
 * @returns The log level or the default value (LogLevel.Error) if not present
 */
export const getLoglevel = (details) => {
    var _a;
    return (details === null || details === void 0 ? void 0 : details.logLevel) || ((_a = details === null || details === void 0 ? void 0 : details.config) === null || _a === void 0 ? void 0 : _a.logLevel) || LogLevel.Error;
};
/**
 * Get/Create the error container in the DOM
 * @public
 * @param id - The id of the container
 * @param tagName - The tag name to create prefix for the design system provider
 * @returns
 */
export const getErrorContainer = (id, tagName) => {
    const tagPrefix = tagName.split('-')[0];
    let container = document.querySelector(`#${id}`);
    if (!container) {
        container = document.createElement('div');
        container.setAttribute('id', id);
        const dsProvider = document.createElement(`${tagPrefix}-design-system-provider`);
        dsProvider.appendChild(container);
        document.body.appendChild(dsProvider);
    }
    return container;
};
/**
 * Get the error banner anchor to attach the banner to
 * @public
 * @param element - The element to start searching from
 * @returns
 */
export const getErrorBannerAnchor = (element) => {
    var _a, _b;
    while (element && !(element instanceof ShadowRoot)) {
        const anchor = (_a = element === null || element === void 0 ? void 0 : element.getRootNode()) === null || _a === void 0 ? void 0 : _a.getElementById('error-banner-anchor');
        if (anchor) {
            anchor.style.position = 'relative';
            return anchor;
        }
        element = (_b = element === null || element === void 0 ? void 0 : element.getRootNode()) === null || _b === void 0 ? void 0 : _b.host;
    }
    return createErrorBannerContainer();
};
const createErrorBannerContainer = () => {
    const anchor = document.createElement('div');
    anchor.setAttribute('id', 'error-banner-anchor');
    anchor.style.position = 'relative';
    document.body.insertBefore(anchor, document.body.firstChild);
    return anchor;
};
